import i18n from 'i18next';
// @ts-ignore
import { getRoutesList } from 'eduki-routes';
import { world } from '../languages';
// @ts-ignore
const ROUTES = getRoutesList(world, i18n);

export default ROUTES;
